"use client";

import { useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";

export function useInviteRedirect() {
    const router = useRouter();
    const searchParams = useSearchParams();

    useEffect(() => {
        if (searchParams.has("token")) {
            router.replace(
                `/auth/invitation/activate?token=${searchParams.get("token")}`
            );
        }
    }, [searchParams, router]);
}
